import React from 'react';
import './Page.css';

const contact = props => (
            <div className="page">
                <h1>Contact Us</h1>
                <p className="page__text contact">Phone:</p>
                <p className="page__text contact"><a href="tel:321-402-7135">321-402-7135</a></p>
                <p className="page__text contact">Email:</p>
                <p className="page__text contact"><a href="mailto:info@campthefork.com">info@campthefork.com</a></p>
            </div>
);

export default contact;